export default __webpack_public_path__ + "static/media/play.b87cf51e.svg";